import React from "react";
import { NavLink } from "react-router-dom";

const Four_blocks_container = () => {
  return (
    <section className="four-blocks-container">
      <div className="row">
        <div className="col-3 img-block">
          <figure>
            <img
              src={`/img/crmstudio_showcase.png`}
              alt="Creatio CRM"
            />
          </figure>
        </div>
        <div className="col-3 content-block">
          <span className="tag">CRM STUDIO</span>
          <h3>CRM Studio born out of No Code Platform</h3>
          <p style={{ margin: "16px 0" }}>
            Virtuos CRM Studio — the industry specific CRM Suite powered by no
            code platform delivers top-notch functionality to configure your
            processes in real-time.
          </p>
          <span className="btn-wrapper">
            <NavLink
              style={{ color: "black" }}
              to={"https://www.crmstudio.com"}
              target="_blank"
              // to={`${process.env.REACT_APP_MEDIA_URL}`}
              className="btn"
            >
              Explore more insights <i className="fal fa-long-arrow-right"></i>
            </NavLink>
          </span>
        </div>
        <div className="col-3 img-block">
          <figure>
            <img
              src={`${process.env.REACT_APP_MEDIA_URL}/img/skillnow.webp`}
              alt="Skillnow"
            />
          </figure>
        </div>
        <div className="col-3 content-block">
          <span className="tag">Skillnow Agile Learning</span>
          <h3>Boost Digital Skills with the Agile Learning Platform.</h3>
          <p style={{ margin: "16px 0" }}>
            Unlock upskilling and reskilling to futureproof your employees and
            enterprise and deliver business outcomes with Skillnow Agile
            Learning Platform.
          </p>
          <span className="btn-wrapper">
            <NavLink
              style={{ color: "black" }}
              target="_blank"
              to={"https://www.skillnow.com"}

              // to={`${process.env.REACT_APP_MEDIA_URL}`}
              className="btn"
            >
               Explore more insights <i className="fal fa-long-arrow-right"></i>
            </NavLink>
          </span>
        </div>
      </div>
    </section>
  );
};

export default Four_blocks_container;
